import { Auth0Provider as RawAuth0Provider } from '@auth0/auth0-react';
import type { PropsWithChildren } from 'react';
import { getConfig } from '@/lib/config';

export function Auth0Provider({ children }: PropsWithChildren) {
  // main.tsx awaits loadConfig() before mounting React, so getConfig() is
  // always populated by the time this component renders.
  const { auth0 } = getConfig();
  const redirectUri = `${window.location.origin}/auth/callback`;

  if (!auth0.domain || !auth0.clientId) {
    if (import.meta.env.DEV) {
      console.warn(
        '[auth] auth0.domain / auth0.clientId missing from /config.json. ' +
          'In containers the entrypoint writes config.json from KV-backed env vars; ' +
          'in `npm run dev` it falls back to DEV_FALLBACK in lib/config.ts.',
      );
    }
  }

  return (
    <RawAuth0Provider
      domain={auth0.domain || 'placeholder.us.auth0.com'}
      clientId={auth0.clientId || 'placeholder'}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: auth0.audience,
        // offline_access is REQUIRED for useRefreshTokens to receive a refresh token;
        // without it silent renewal fails with "Missing Refresh Token" once the access
        // token expires. (The Auth0 API must also have "Allow Offline Access" enabled.)
        scope: 'openid profile email offline_access',
      }}
      cacheLocation="localstorage"
      useRefreshTokens
    >
      {children}
    </RawAuth0Provider>
  );
}
